import { useState, useEffect } from "react";
import { ProveedorModel, ProveedorSelectModel } from "../models/ProveedorModel";
import { useHistory } from "react-router-dom";
import { obtenerProveedoresSelect, obtenerProveedoresService, obtenerProveedorPorIDService } from "../../../service/proveedores/Proveedores";

export const useObtenerProveedores = (loading: number) => {
  const [data, setData] = useState<ProveedorModel[]>([]);
  const [count, setCount] = useState(1);
  const [loadingRequest, setLoadingRequest] = useState<boolean>(false);
  const history = useHistory();

  useEffect(() => {
    const fetchPost = async () => {
      setLoadingRequest(true);
      const data = await obtenerProveedoresService()
        .then()
        .catch((error) => {
          setLoadingRequest(false);

          history.push("/error/500");
        });
      if (data) {
        setData(data.rows);
        setCount(data.count);
        setLoadingRequest(false);
      }
    };
    fetchPost();
  }, [loading]);
  return { data, count, loadingRequest };
};

export const useObtenerPorId = (id: number) => {
  const initModel = {
    id: 0,
    nombre: "",
    nombre_contacto: "",
    telefono: "",
  };
  const [initValues, setInitValues] = useState<ProveedorModel>(initModel);

  const history = useHistory();
  useEffect(() => {
    const fetchPost = async () => {
      const res = await obtenerProveedorPorIDService(id)
        .then()
        .catch((error) => {
          history.push("/error/500");
        });
      if (res) {
        setInitValues(res);
      }
    };
    if (id) {
      fetchPost();
    } else {
      setInitValues(initModel);
    }
  }, [id]);

  return { initValues };
};

export const useObtenerProveedoresSelect = (realoadGrid: number) => {
  const [list, setList] = useState<ProveedorSelectModel[]>([]);
  const [loading, setLoading] = useState(true);
  const history = useHistory();

  useEffect(() => {
    const fetchPost = async () => {
      const res = await obtenerProveedoresSelect()
        .then()
        .catch((error) => {
          history.push("/error/500");
        });
      if (res) {
        setList(res);
        setLoading(false);
      }
    };

    fetchPost();
  }, [realoadGrid]);

  return { list, loading };
};
